import { setCopyButtonComponent } from './interactions/copy-button';
import HotPolyTitle from './interactions/tooltip/components/common/HotPolyTitle';
import TcfTooltip from './interactions/tooltip/components/TcfTooltip';
import { SlotLayer } from './layers/custom/slot/slot-layer';
import _palettes, { getLegendDisplayPalettes, getPalette } from './palettes/palettes';
import _altitudeGroups, { altitudeGroupsFlat as _altitudeGroupsFlat } from './products/altitudeGroups';
import _categories from './products/categories';
import _products, {
    productAltitudeGrouped as _productAltitudeGrouped,
    productsFlat as _productsFlat,
    CMP,
    getQualifiedId,
    SFC
} from './products/products';
import { getSeverityString, isTracksProduct } from './utils/utils';
import { removeGlobalDispatcher } from './worker/dispatcher';
export * from './gdf/gdf-parser';
export * from './gdf/type';
export * from './interactions/context-menu/index';
export { hasTooltip, WeatherTooltip } from './interactions/tooltip/WeatherTooltip';
export type * from './manager/types';
export * from './manager/weather-layer-manager';
export type * from './palettes/palettes';
export { type AltitudeGroup } from './products/altitudeGroups';
export * from './products/categories';
export { ProductCategory } from './products/categories';
export { type WeatherProduct } from './products/products';
export * from './service/types';
export * from './service/weather-layer-plugin';
export { animationRangeValues } from './service/weather-timeline';
export { DEFAULT_WEATHER_SETTINGS } from './settings/default';
export * from './settings/settings';
export * from './utils/enum-display';
export { MS_TO_KT } from './utils/geo';
export * from './utils/utils';
export { WeatherLoader, WeatherServerStrategy } from './weather-loader';
export type { WeatherLoaderWebSource } from './weather-loader';
export type { WeatherStoreProductFrameInfo, WeatherStoreProductFrameTimeInfo, WeatherStoreProductInfo } from './worker/store/weather-store';
export {
    CMP,
    getLegendDisplayPalettes,
    getPalette,
    getQualifiedId,
    getSeverityString,
    HotPolyTitle,
    isTracksProduct,
    setCopyButtonComponent,
    SFC,
    SlotLayer,
    TcfTooltip as TcfDetails,
    removeGlobalDispatcher as weatherDisposeWorker
};
export const products = _products;
export const productsFlat = _productsFlat;
export const productAltitudeGrouped = _productAltitudeGrouped;

export const categories = _categories;
export const altitudeGroups = _altitudeGroups;
export const altitudeGroupsFlat = _altitudeGroupsFlat;
/**
 * @deprecated use {@link getPalette}
 */
export const palettes = _palettes;
export { setWorkerFactory } from './worker/dispatcher';
